import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { USER_LOGIN_DATA } from '../constants/ActionTypes';
import './DigitexSsoCallback.css';

const DIGITEX_APP_URL = process.env.REACT_APP_DIGITEX_APP_URL || 'https://digitex.filmar.it';

const getDigitexHomeUrl = (returnUrl) => {
  try {
    const expectedOrigin = new URL(DIGITEX_APP_URL).origin;
    if (returnUrl && new URL(returnUrl).origin === expectedOrigin) {
      return `${expectedOrigin}/home`;
    }
    return `${expectedOrigin}/home`;
  } catch {
    return 'https://digitex.filmar.it/home';
  }
};

export const DigitexSsoLoading = ({ label = 'Accesso al sito Filmar in corso' }) => (
  <main className="digitex-sso-screen" role="status" aria-label={label} aria-busy="true">
    <span className="digitex-sso-spinner" aria-hidden="true" />
  </main>
);

const DigitexSsoCallback = () => {
  const dispatch = useDispatch();
  const started = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    const exchange = async () => {
      const code = new URLSearchParams(window.location.search).get('code');
      if (!code) {
        setError('Codice di accesso Digitex mancante.');
        return;
      }

      try {
        const response = await axios.post('/v1/digitex/exchange', { code });
        const { user, token } = response.data || {};
        if (!response.data?.success || !user || !token) {
          throw new Error(response.data?.message || 'Risposta SSO del sito Filmar non valida.');
        }

        const authenticatedUser = { ...user, token };
        localStorage.setItem('token', token);
        localStorage.setItem('userDataDetail', JSON.stringify(authenticatedUser));
        localStorage.removeItem('agentDataDetail');
        dispatch({ type: USER_LOGIN_DATA, userdetailData: authenticatedUser });
        window.history.replaceState({}, document.title, '/digitex-sso-callback');
        window.location.replace('/');
      } catch (requestError) {
        window.history.replaceState({}, document.title, '/digitex-sso-callback');
        setError(requestError?.response?.data?.message || requestError.message || 'Accesso al sito Filmar non riuscito.');
      }
    };

    exchange();
  }, [dispatch]);

  if (error) {
    return (
      <main className="digitex-sso-screen digitex-sso-screen--error">
        <p role="alert">{error}</p>
        <a href={getDigitexHomeUrl()} style={{ justifySelf: 'center' }}>Torna a Digitex</a>
      </main>
    );
  }

  return <DigitexSsoLoading />;
};

export default DigitexSsoCallback;
